import { useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const useHashState = () => {
  const history = useHistory();

  const getPlainHash = useCallback(hash => {
    if (!hash) return null;
    return hash.split('#')[1] || null;
  }, []);

  const [hash, setHash] = useState(getPlainHash(history.location.hash));

  useEffect(() => {
    const unListen = history.listen(location => {
      setHash(getPlainHash(location.hash));
    });

    return () => {
      unListen();
    };
  }, [history]);

  const setNewHash = useCallback(
    (newHash: string | number | null) => {
      const currentLocation = history.location;
      const newLocation = {
        pathname: currentLocation.pathname,
        search: currentLocation.search,
        hash: newHash ? `#${newHash}` : null,
      };
      history.push(newLocation);
    },
    [history],
  );

  return [hash, setNewHash];
};

export default useHashState;
